import { Route, Routes } from "react-router-dom";
import NotifyPage from "./notify";

export default function NotifyRouter() {
  return (
    <Routes>
      <Route path="" element={<NotifyPage />} />
    </Routes>
  );
}
